import { MuiF } from '../../../../../../../Mui/F/Function/module/MuiF.js';
import { VectorEditorStickerSingleCreatorPCCuttingLineAutoMuiF } from '../Mui/module/VectorEditorStickerSingleCreatorPCCuttingLineAutoMuiF.js';

export const makeCuttingLineAuto = ({
  single_sticker_editor,
  postProcess,
  editor_padding: {
    top: editor_padding_top,
    right: editor_padding_right,
    bottom: editor_padding_bottom,
    left: editor_padding_left,
  },
}) =>
  MuiF.pushPage(VectorEditorStickerSingleCreatorPCCuttingLineAutoMuiF.page, (page, [tab]) => {
    const tab_appending = tab.appending;
    tab.appending = (tab_el) => {
      tab_el.__mp_single_sticker_editor = single_sticker_editor;
      tab_el.__mp_postProcess = postProcess;
      tab_el.__mp_editor_padding_top = editor_padding_top;
      tab_el.__mp_editor_padding_bottom = editor_padding_bottom;
      tab_el.__mp_editor_padding_left = editor_padding_left;
      tab_el.__mp_editor_padding_right = editor_padding_right;

      return tab_appending.call(tab, tab_el);
    };
  }).catch(async (error) => {
    await MuiF.popPage();
    throw error;
  });
